module.exports = __webpack_public_path__ + "img/UT0408.bf3c350e.png";